/**
 * @generated SignedSource<<3afc9b327f15fd6f4241a59fb2be1953>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type StorefrontProfilesStatus = "LIVE" | "WORK_IN_PROGRESS" | "UNDER_REVIEW" | "REJECTED" | "PENDING_TRANSLATION" | "DELETED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedStorefrontCreatorLink_browseContentModule$data = {
  readonly seller: {
    readonly sellerProfile: {
      readonly company: string | null;
    } | null;
    readonly sellerPreferences: {
      readonly urlLabel: string | null;
    } | null;
    readonly liveStorefrontProfile: {
      readonly status: StorefrontProfilesStatus | null;
    } | null;
  } | null;
  readonly " $fragmentType": "SbSharedStorefrontCreatorLink_browseContentModule";
};
export type SbSharedStorefrontCreatorLink_browseContentModule$key = {
  readonly " $data"?: SbSharedStorefrontCreatorLink_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedStorefrontCreatorLink_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedStorefrontCreatorLink_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerProfile",
          "kind": "LinkedField",
          "name": "sellerProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerPreferences",
          "kind": "LinkedField",
          "name": "sellerPreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "kind": "LinkedField",
          "name": "liveStorefrontProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentModuleCreator",
  "abstractKey": null
};

(node as any).hash = "ca3d9e76c79fb35a1ed552277f792b27";

export default node;
